<template>
    <div class="warehouse">
        <el-form :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini" :inline="true">
            <el-form-item :label="$t('form_warehouse')">
                <el-select ref="dqs"
                           v-model="formData.addList"
                           :placeholder="$t('form_please_select_warehouse')"
                           style="width: 300px;"
                           multiple filterable required clearable
                           @change="addWarehouse">
                    <el-option
                            v-for="one in spList"
                            :key="one.i_ckid"
                            :label="one.vc_ckname"
                            :value="one.i_ckid">
                        <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="录入人">
                <el-input v-model="formData.name" disabled ></el-input>
            </el-form-item>
        </el-form>
            <el-table
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column width="50px" align="center" type="index" :label="$t('form_serial_number')"></el-table-column>
                <el-table-column width="" align="center" prop="vc_ckname" :label="$t('form_warehouse')"></el-table-column>
                <el-table-column width="" align="center" prop="vc_lruname" label="录入人"></el-table-column>
                <el-table-column width="" align="center" prop="dt_createtime" label="录入时间"></el-table-column>
                <el-table-column align="center" label="操作" width="90" prop="i_isContainR">
                    <template slot-scope="scope">
                        <el-button  @click="deleteBtn(scope.row,scope.$index)" type="text" size="mini" v-if="scope.row.i_id!=0">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        <!--<el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total">
        </el-pagination>-->
        <div class="pz" style="text-align: center">
            <el-button class="bcBtn" @click="saveBtn" :class="baseerp+'btn'" size="mini" :disabled="disabled">
                保存
            </el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>

</template>

<script>
    import * as API from  "./../api";
    import {baseerp} from "@/utils/baseUrl";
    import {filerequest_url} from './../api';
    export default {
        name: 'WarehouseM',
        props:{
            warehouse:{
                type: Object,
                required:true,
            }
        },
        data(){
            return{
                baseerp:"",
                formData:{
                    addList:[],
                    name:sessionStorage.getItem("lruname"),
                },
                formRules: {
                    addList: [{required: true, message: "请选择仓库", trigger: "change"}],
                },
                spList:[],
                addList:[],
                delList:[],
                tableData:[],
                bftableData:[],
                tableHeight:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                i_pid:'',
                pageSize:1,
                currentPage:1,
                total:0,
                disabled:false,
            }
        },
        mounted() {
            this.i_pid=this.warehouse.i_id;
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
            this.baseerp=baseerp;
            this.getWarehouseList();
            this.getDbWarehouseList();
        },
        methods:{
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 330;
            },
            async getWarehouseList(){
                let params={
                    // i_mid:this.mid
                };
                let res=await API.getWarehouseList(params);
                if(res.code==1){
                    this.spList=res.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            async getDbWarehouseList(){
                let params={
                    // i_mid:this.mid
                    i_pid:this.i_pid,
                    pageStart:this.pageSize,
                    pageSize:15,
                };
                let res=await API.getDbWarehouseList(params);
                if(res.code==1){
                    if (res.list.length==0) {this.dataText='暂无数据'};
                    this.tableData=res.list;
                    this.bftableData=JSON.parse(JSON.stringify(res.list));
                    this.total=res.count;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }

            },
            addWarehouse(val){
                let arr=[];
                val.map(one=>{
                    let hash=this.spList.find(two=>two.i_ckid==one);
                    let ware={
                        i_id:0,
                        vc_ckname:hash.vc_ckname,
                        i_ckid:one,
                        i_lruid:sessionStorage.getItem("userid"),
                        i_pid: this.i_pid,
                    }
                        arr.push(ware);
                })
                //console.log(arr,"arr")
                this.tableData=this.bftableData.concat(arr);
                this.addList=arr;
                // this.wareidList=val
                // let labels=this.spList.find(item=>item.i_ckid==val.i_ckid).vc_ckname
                //console.log(val,"val",)
            },
            async saveBtn(){
                this.disabled=true;
               /* this.formData.addList.map(one=>{
                    let hash=this.spList.find(two=>two.i_ckid==one);
                    let ware={
                        i_id:0,
                        i_ckid:hash.i_ckid,
                        i_lruid:sessionStorage.getItem("userid"),
                        i_pid: this.i_pid,
                    }
                    this.addList.push(ware);
                })*/
                //console.log(this.addList,"this.formData.addList");
                if (this.addList.length!=0){
                    let params={
                        i_pid:this.warehouse.i_id,
                        addList:this.addList,
                        // delList:this.delList,
                        // updateList:[],
                    };
                    let res=await API.saveDbWarehouse(params);
                    if(res.code==1){
                        this.$emit('getOriginList');
                        this.cancel();
                    }else if (res.code == -2) {
                        this.disabled=false;
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else{
                        this.disabled=false;
                        this.$message.error(res.message);
                    }
                }else {
                    this.$message.error("请选择添加仓库");
                    this.disabled=false;
                }

            },
            deleteBtn(row,index){
                if (row.i_id!=0){
                    this.$confirm('确定删除已保存的仓库?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                            let params={
                                i_id:row.i_id,
                            };
                            let res=await API.delDbWarehouse(params);
                            if(res.code==1){
                                this.tableData.splice(index,1);
                                this.bftableData.splice(index,1);
                            }else if (res.code == -2) {
                                this.$router.push('/login');
                                this.$message.error(res.message);
                            }
                            else{
                                this.$message.error(res.message);
                            }
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }
            },
            cancel(){
                this.$emit('closeW')
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },

    }
</script>

<style lang="scss" >
    .warehouse{
        .flex{
            display: flex;
        }
        .el-select{
            max-height: 54px;
        }
        .el-select__tags{
            max-height: 52px;
            overflow-y: auto;
        }
    }

</style>